// extracted by mini-css-extract-plugin
export var navLinkWrapper = "styles-module--navLinkWrapper--yBGPt";
export var navLink = "styles-module--navLink--Zrb8+";
export var activeLink = "styles-module--activeLink--KsYlT";
export var darkMode = "styles-module--darkMode--al5TV";
export var open = "styles-module--open--iWaCK";
export var contactButton = "styles-module--contactButton--RComE";
export var menuButtonContainer = "styles-module--menuButtonContainer--sxpvB";